import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"

import { createRolePermissionMethods } from "~/modules/roles-and-permissions/role-permission-methods"
import { getUnitBySlugQueryOptions } from "~/modules/units/queries"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/_admin-layout",
)({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const permissionMethods = createRolePermissionMethods(
      context.appRole,
      context.rolePermissions,
    )

    if (!permissionMethods.doesRoleHaveAdminZoneAccess()) {
      throw notFound()
    }

    const internalAccount = await context.queryClient.ensureQueryData(
      getUnitBySlugQueryOptions("internal", "internal"),
    )

    if (!internalAccount) {
      throw notFound()
    }

    return {
      internalAccount,
    }
  },
})

function RouteComponent() {
  return <Outlet />
}
